import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { StateContext } from '../../../../../StateProvider';
import Popup from '../../../../../Utilities/components/Popup';
import { BackButton } from '../../../../../Utilities/components/Buttons';
import { cancelClubMembership } from '../../../../../Utilities/api';
import './MembershipEdit.css';

const MembershipEdit = () => {
  const { user, refreshUserData } = useContext(StateContext);
  const navigate = useNavigate();

  const [membership, setMembership] = useState(null);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && user.clubMembership) {
      setMembership(user.clubMembership);
    }
    setLoading(false);
  }, [user]);

  const handleCancelMembership = async () => {
    try {
        await cancelClubMembership(membership.id);
        await refreshUserData(user.uid);
        setShowCancelPopup(false);
        navigate('/profile');
    } catch (err) {
        console.error('Cancel error:', err);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!membership) return <div>No active membership found.</div>;

  const formattedPrice = (membership.priceCents / 100).toFixed(2);
  const startDate = new Date(membership.startDate).toLocaleDateString();
  const nextBilling = membership.nextBillingDate
    ? new Date(membership.nextBillingDate).toLocaleDateString()
    : 'N/A';

  return (
    <div className="container">
      <BackButton />
      <div className="membership-edit-backdrop">
        <Popup isOpen={showCancelPopup} handleClose={() => setShowCancelPopup(false)}>
          <p className="membership-edit-popup-header">Cancel Membership?</p>
          <p className="membership-edit-popup-message">
            Are you sure you want to cancel your Pawsible {membership.planType} Club membership?
          </p>
          <p className="membership-edit-popup-message">
            Your benefits will remain active until the current billing period ends.
          </p>
          <div className="membership-edit-popup-button-container">
            <button onClick={handleCancelMembership} className="membership-edit-popup-delete">
              Confirm
            </button>
            <button onClick={() => setShowCancelPopup(false)} className="membership-edit-popup-cancel">
              Keep Membership
            </button>
          </div>
        </Popup>

        <div className="membership-edit-form">
          <div className="membership-edit-section">
            <h2 className="membership-edit-header">Membership Details</h2>
            <p><strong>Plan:</strong> Pawsible {membership.planType} Club</p>
            <p><strong>Price:</strong> ${formattedPrice}/month</p>
            <p><strong>Status:</strong> {membership.billingStatus}</p>
            <p><strong>Start Date:</strong> {startDate}</p>
            <p><strong>Next Billing:</strong> {nextBilling}</p>
          </div>

          <div className="membership-edit-section">
            <h2 className="membership-edit-header">Member Perks</h2>
            <div className="membership-edit-benefits">
              <ul>
                {membership.perks && membership.perks.length > 0 ? (
                  membership.perks.map((perk, idx) => (
                    <li key={idx}>{perk}</li>
                  ))
                ) : (
                  <li>No perks listed.</li>
                )}
              </ul>
            </div>
          </div>

          <div className="membership-edit-buttons-container">
            <button
              type="button"
              onClick={() => navigate('/support')}
              className="membership-edit-contact-support-button"
            >
              Help
            </button>
            <button
              type="button"
              onClick={() => setShowCancelPopup(true)}
              className="membership-edit-cancel-button"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipEdit;
